import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { BASE_URL } from "config/api";

const getShareBaseUrl = (): string => {
  const configuredBaseUrl = process.env.REACT_APP_SHARE_BASE_URL?.trim();
  if (configuredBaseUrl) {
    return configuredBaseUrl.replace(/\/+$/, "");
  }

  const apiRoot = BASE_URL.replace(/\/api\/v1\/?$/, "").replace(/\/+$/, "");
  if (/^https:\/\/api\.bosscarnetwork\.com$/i.test(apiRoot)) {
    return "https://app.bosscarnetwork.com";
  }

  return apiRoot;
};

const ShareRedirectPage: React.FC = () => {
  const { id = "" } = useParams<{ id: string }>();

  const targetUrl = useMemo(() => {
    const shareBaseUrl = getShareBaseUrl();
    if (!id) {
      return shareBaseUrl;
    }

    return `${shareBaseUrl}/share/${id}`;
  }, [id]);

  useEffect(() => {
    window.location.replace(targetUrl);
  }, [targetUrl]);

  return (
    <div className="min-h-screen bg-[#f4f5fb] text-[#22253a] flex items-center justify-center p-6">
      <div className="w-full max-w-xl rounded-2xl border border-[#eceef6] bg-white p-8 text-center shadow-[0_12px_30px_rgba(24,31,62,0.14)]">
        <p className="text-sm uppercase tracking-[0.24em] text-[#7f879e] mb-3">
          BossCar Share
        </p>
        <h1 className="text-2xl font-semibold mb-3">Redirecting to the public share page</h1>
        <p className="text-[#636983] mb-6">
          This link now opens from the public BossCar share system instead of the dashboard.
        </p>
        <a
          href={targetUrl}
          className="inline-flex items-center justify-center rounded-xl bg-[#2f3246] px-5 py-3 font-medium text-white"
        >
          Continue
        </a>
      </div>
    </div>
  );
};

export default ShareRedirectPage;
